module.exports = __webpack_public_path__ + "static/media/anxious.605a6522.svg";